import {isEmpty, negate} from 'lodash/fp'

import {PathsIn} from './src'

export * from './src'
export {addQuery} from './url'
export {getUUID} from './uuid'
/** @see https://github.com/leizongmin/js-xss */
export {default as sanitize} from 'xss'
// ре-экспортим лодаш, чтобы в будущем либо избавиться от него, либо заменить на ramda
export {chunk, debounce, sortBy} from 'lodash'
export {
  add,
  allPass,
  anyPass,
  cond,
  constant,
  curryRight,
  defaultTo,
  equals,
  every,
  filter,
  find,
  findIndex,
  flatten,
  groupBy,
  has,
  includes,
  isArray,
  isEmpty,
  isEqual,
  isNil,
  isNull,
  isNumber,
  isString,
  isUndefined,
  join,
  map,
  max,
  merge,
  negate,
  noop,
  omit,
  omitBy,
  pick,
  pickBy,
  prop,
  random,
  reduce,
  replace,
  set,
  some,
  split,
  stubArray,
  stubFalse,
  stubObject,
  stubString,
  stubTrue,
  takeRight,
  toLower,
  trim,
  uniqBy,
  uniqueId,
  values,
  xor,
} from 'lodash/fp'
export {default as applySpec} from 'ramda/src/applySpec'
export {default as ifElse} from 'ramda/src/ifElse'
export {default as tap} from 'ramda/src/tap'
export {useScrollbarWidth} from 'react-use'
export {compose, pipeline as flow, pipe} from 'ts-pipe-compose'

export const toNumber = (value: string | number | undefined, defaultValue = 0): number => {
  // важная штука (NaN || 0) вернет 0
  // лодаш не подходит потому что возвращает NaN, смысла его обрабатывать отдельно я не вижу
  return Number(value) || defaultValue
}

export const isFilled = negate(isEmpty) as <T>(v?: T) => v is T

export const delay = (timeoutMs: number = 1000) => new Promise<void>(resolve => setTimeout(resolve, timeoutMs))

export function identity<T extends unknown>(v: T) {
  return v
}

export function modelPath<Model>() {
  type ValidatePathFunction = <P extends PathsIn<Model>>(path: P) => P
  // юзаем identity, жрем на пару байт оперативы меньше 🥷
  return identity as ValidatePathFunction
}

export function absurd(arg: never): never {
  throw new Error(`Non-exhaustive switch statement with ${arg}`)
}
